import React, { FC } from 'react';
import { useOrchestratorState } from '@wix/gg-components/orchestrator';
import styles from './Header.scss';
import { HeaderLogo } from './HeaderLogo';
import { HeaderProgress } from './HeaderProgress';
import { useIsMobile } from 'hooks/useIsMobile';
import { StepParams } from 'types/steps';

export const Header: FC = () => {
  const isMobile = useIsMobile();
  const { currentStep } = useOrchestratorState<StepParams>();
  const showProgress = currentStep?.params?.hideProgress !== true;

  if (isMobile) {
    return (
      <div className={styles.header}>
        <div className={styles.headerLogoContainer}>
          <HeaderLogo />
        </div>
        {showProgress && (
          <div className={styles.headerProgressContainer}>
            <HeaderProgress />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.header}>
      <HeaderLogo />
      <HeaderProgress />
    </div>
  );
};
